import React from 'react';
import VodOverlay from './VodOverlay/VodOverlay';

const VodPoster = ({ vod }) => {
  const { title, cover, link } = vod;

  return (
    <div className="movie-poster" style={{ display: 'inline-block' }}>
      <div className="movie-poster-preview">
        <a href={link} target="_blank">
          <img src={cover} title={title} />
        </a>
      </div>
      <VodOverlay vod={vod} />
    </div>
  );
};

export default VodPoster;
